import './assets/fonts/fonts.css';

import { QueryClientProvider } from '@tanstack/react-query';
import { NotificationsProvider } from '@toolpad/core';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { Box, CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { GlobalStyles } from '@mui/styled-engine';

import { queryClient } from './api/query-client';
import App from './app/App';
import {
  AuthContextProvider,
  LoaderContextProvider,
  RedirectsProvider,
} from './assets/context-providers';
import { waitForAppFonts } from './assets/helpers/utils/wait-for-app-fonts.ts';
import { Loader } from './components/loader';
import { QueryErrorNotifier } from './components/query-error-notifier';
import theme from './theme';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const app = (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <LoaderContextProvider>
        <NotificationsProvider>
          <QueryErrorNotifier />
          <AuthContextProvider>
            <RedirectsProvider>
              <CssBaseline />
              <App />
              <GlobalStyles
                styles={{
                  'html, body': {
                    backgroundColor: '#F5F5F5',
                  },
                  '*, *::before, *::after': {
                    boxSizing: 'border-box',
                  },
                }}
              />
            </RedirectsProvider>
          </AuthContextProvider>
        </NotificationsProvider>
      </LoaderContextProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

// Render only a text-free loading state until all application font weights have settled.
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Box sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center' }}>
      <Loader color="accent" />
    </Box>
  </ThemeProvider>
);

void waitForAppFonts().then(() => root.render(app));
